import { useQuery } from '@tanstack/react-query';

import { listAgencies } from '~/services/AgentHub/AgentService';

import { ListAgencyParams } from '~/types/services/agentHub';

interface UseListAgenciesParams {
  brand: ListAgencyParams['brand'];
  affiliationId: string;
  enabled?: boolean;
}

export function useListAgencies({ brand, affiliationId, enabled = true }: UseListAgenciesParams) {
  return useQuery({
    queryKey: ['agencies', brand, affiliationId],
    queryFn: async () => {
      const result = await listAgencies({
        brand,
        affiliationId,
        page: '0',
        pageSize: '100',
      });
      return result.rows;
    },
    enabled: enabled && !!affiliationId,
  });
}
